"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _styledComponents = require("styled-components");
var _recharts = require("recharts");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const BarChart = _ref => {
  let {
    config = [],
    data = [],
    disabled = false,
    fontSize = "12px",
    height = 400,
    inverted = false,
    labelMaxLength,
    labelMirror = false,
    legend = false,
    maxBarSize,
    minHeight,
    minWidth,
    width = "100%",
    onClick,
    selected,
    stacked = false,
    tickFormatter = value => value,
    tooltip = true,
    vertical = false,
    xAxisVerticalHeight = 200
  } = _ref;
  const selectedBool = typeof selected === 'object' ? !(0, _isEmpty.default)(selected) : !!selected;
  const {
    overPrimaryColor = '#FFFFFF',
    primaryColor,
    primaryLighterColor,
    textColor
  } = (0, _styledComponents.useTheme)();
  const checkSelection = value => {
    if (typeof selected === 'string') return value === selected;
    if (!selected) return false;
    return selected.includes(value);
  };
  const getLabel = key => {
    var _config$find$label, _config$find;
    return (_config$find$label = (_config$find = config.find(_ref2 => {
      let {
        dataKey
      } = _ref2;
      return dataKey === key;
    })) === null || _config$find === void 0 ? void 0 : _config$find.label) !== null && _config$find$label !== void 0 ? _config$find$label : key;
  };
  const getXTickText = value => {
    if (!value) return '';
    if (!labelMaxLength || value.length <= labelMaxLength) return value;
    return "".concat(value.substring(0, labelMaxLength).trim(), "...");
  };
  const CustomMirrorTick = _ref3 => {
    let {
      payload: {
        value
      },
      x,
      y
    } = _ref3;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(".concat(x, ",").concat(y, ")"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
        dy: !inverted ? 0 : 4,
        fill: checkSelection(value) ? overPrimaryColor : textColor,
        fontSize: fontSize,
        textAnchor: !inverted ? 'middle' : 'start',
        x: 0,
        y: 0,
        children: getXTickText(value)
      })
    });
  };
  const CustomVerticalTick = _ref4 => {
    let {
      payload: {
        value
      },
      x,
      y
    } = _ref4;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(".concat(x, ",").concat(y, ")"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
        dy: 16,
        fill: textColor,
        fontSize: fontSize,
        textAnchor: "end",
        transform: "rotate(-30)",
        x: 0,
        y: 0,
        children: getXTickText(value)
      })
    });
  };
  const CustomTooltip = _ref5 => {
    let {
      active,
      payload
    } = _ref5;
    if (!active || (0, _isEmpty.default)(payload) || (0, _isEmpty.default)(config)) return null;
    const {
      payload: dataPayload
    } = payload[0];
    if (config.length === 1) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.TooltipContainer, {
        tabIndex: "-1",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.TooltipValue, {
          margin: "0px",
          children: [dataPayload.label, ": ", getLabel(dataPayload[config[0].dataKey])]
        })
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.TooltipContainer, {
      tabIndex: "-1",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.TooltipLabel, {
        children: dataPayload.label
      }), config.map(_ref6 => {
        let {
          dataKey
        } = _ref6;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.TooltipValue, {
          margin: "5px 0px 0px 0px",
          children: [getLabel(dataKey), ": ", dataPayload[dataKey]]
        }, dataKey);
      })]
    });
  };
  const handleClick = (barData, index) => {
    if ((0, _isEmpty.default)(barData) || !onClick || disabled) return;
    onClick(_objectSpread(_objectSpread({}, barData), {}, {
      index
    }));
  };
  const legendFormatter = (_, _ref7) => {
    let {
      dataKey
    } = _ref7;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.LegendSpan, {
      children: getLabel(dataKey)
    });
  };
  const axisStyles = {
    tick: {
      fill: textColor,
      fontSize
    }
  };
  const chartProps = {
    barGap: 0,
    data,
    layout: !inverted ? 'horizontal' : 'vertical',
    margin: '0px',
    opacity: disabled ? 0.4 : 1
  };
  const containerProps = {
    height,
    minHeight,
    minWidth,
    width
  };
  const gridStyle = {
    stroke: primaryLighterColor
  };
  const labelMirrorProps = labelMirror ? {
    mirror: true,
    tick: /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomMirrorTick, {}),
    width: 320
  } : {};
  const verticalProps = vertical ? {
    height: xAxisVerticalHeight,
    tick: /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomVerticalTick, {})
  } : {};
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.ResponsiveContainer, _objectSpread(_objectSpread({}, containerProps), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_recharts.BarChart, _objectSpread(_objectSpread({}, chartProps), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
        children: !stacked && config.map((_ref8, index) => {
          let {
            dataKey,
            fill = primaryColor
          } = _ref8;
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
            id: "color-".concat(dataKey),
            x1: !inverted ? '0' : '1',
            y1: "0",
            x2: "0",
            y2: !inverted ? '1' : '0',
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
              offset: "0%",
              stopColor: fill,
              stopOpacity: 1
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
              offset: !inverted || labelMirror ? '50%' : '80%',
              stopColor: fill,
              stopOpacity: 0.7
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
              offset: "100%",
              stopColor: fill,
              stopOpacity: 0.1
            })]
          }, index);
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.CartesianGrid, {
        horizontal: !inverted,
        vertical: inverted,
        style: gridStyle
      }), config.map((_ref9, index) => {
        let {
          dataKey,
          fill = primaryColor
        } = _ref9;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Bar, {
          animationDuration: 600,
          dataKey: dataKey,
          fill: fill,
          maxBarSize: maxBarSize,
          stackId: stacked ? 1 : undefined,
          children: data.map((barData, index) => {
            const gradient = stacked ? fill : "url(#color-".concat(dataKey, ")");
            const isSelected = checkSelection(barData === null || barData === void 0 ? void 0 : barData.key);
            const fillColor = isSelected ? fill : gradient;
            const isSelectedStyle = isSelected ? {
              opacity: 1,
              stroke: primaryColor,
              strokeWidth: 1
            } : {};
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Cell, _objectSpread({
              cursor: onClick && !disabled ? 'pointer' : undefined,
              fill: fillColor,
              opacity: selectedBool ? 0.6 : 1,
              onClick: () => handleClick(barData, index)
            }, isSelectedStyle), "cell-".concat(index));
          })
        }, index);
      }), !inverted ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.XAxis, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, axisStyles), labelMirrorProps), verticalProps), {}, {
          dataKey: "label",
          interval: 0,
          tickFormatter: getXTickText,
          type: "category"
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.YAxis, _objectSpread(_objectSpread({}, axisStyles), {}, {
          tickFormatter: tickFormatter,
          type: "number",
          width: 40
        }))]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.XAxis, _objectSpread(_objectSpread({}, axisStyles), {}, {
          tickFormatter: tickFormatter,
          type: "number"
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.YAxis, _objectSpread(_objectSpread(_objectSpread({}, axisStyles), labelMirrorProps), {}, {
          dataKey: "label",
          interval: 0,
          tickFormatter: getXTickText,
          type: "category"
        }))]
      }), tooltip && /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Tooltip, {
        content: CustomTooltip,
        cursor: {
          fill: 'transparent'
        },
        wrapperStyle: {
          outline: 'none'
        }
      }), legend && /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Legend, {
        formatter: legendFormatter
      })]
    }))
  }));
};
BarChart.propTypes = {
  config: _propTypes.default.arrayOf(_propTypes.default.shape({
    dataKey: _propTypes.default.string.isRequired,
    fill: _propTypes.default.string,
    label: _propTypes.default.string.isRequired
  })),
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
    label: _propTypes.default.string.isRequired
  })),
  disabled: _propTypes.default.bool,
  fontSize: _propTypes.default.string,
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  inverted: _propTypes.default.bool,
  labelMaxLength: _propTypes.default.number,
  labelMirror: _propTypes.default.bool,
  legend: _propTypes.default.bool,
  maxBarSize: _propTypes.default.number,
  minHeight: _propTypes.default.number,
  minWidth: _propTypes.default.number,
  onClick: _propTypes.default.func,
  selected: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  stacked: _propTypes.default.bool,
  tickFormatter: _propTypes.default.func,
  tooltip: _propTypes.default.bool,
  vertical: _propTypes.default.bool,
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  xAxisVerticalHeight: _propTypes.default.number
};
var _default = exports.default = BarChart;